import { BUILD_SHORT_SHA, VISUAL_QA_ENABLED } from "./build-info";

export const VISUAL_SCENE_IDS = [
  "terrain-ridge",
  "terrain-lake",
  "poi-slope",
  "combat-density",
  "touch-combat",
  "run-debrief",
] as const;

export type VisualSceneId = (typeof VISUAL_SCENE_IDS)[number];

export type VisualScene = {
  id: VisualSceneId;
  seed: number;
  tick: number;
  quality: "high" | "medium" | "low";
};

const SCENES: Record<VisualSceneId, VisualScene> = {
  "terrain-ridge": { id: "terrain-ridge", seed: 4242, tick: 240, quality: "high" },
  "terrain-lake": { id: "terrain-lake", seed: 5150, tick: 240, quality: "high" },
  "poi-slope": { id: "poi-slope", seed: 7291, tick: 240, quality: "high" },
  "combat-density": { id: "combat-density", seed: 9091, tick: 240, quality: "high" },
  "touch-combat": { id: "touch-combat", seed: 8088, tick: 240, quality: "medium" },
  "run-debrief": { id: "run-debrief", seed: 6060, tick: 240, quality: "medium" },
};

export function visualSceneFromLocation(search = window.location.search): VisualScene | null {
  if (!VISUAL_QA_ENABLED) return null;
  const id = new URLSearchParams(search).get("visualScene") as VisualSceneId | null;
  if (!id || !VISUAL_SCENE_IDS.includes(id)) return null;
  const requestedQuality = new URLSearchParams(search).get("quality");
  const quality =
    requestedQuality === "high" || requestedQuality === "medium" || requestedQuality === "low"
      ? requestedQuality
      : SCENES[id].quality;
  return { ...SCENES[id], quality };
}

export function installVisualQaStamp(host: HTMLElement, scene: VisualScene): void {
  document.documentElement.dataset.visualScene = scene.id;
  document.documentElement.dataset.visualFixtureReady = "true";
  const stamp = document.createElement("output");
  stamp.className = "visual-qa-stamp";
  stamp.setAttribute("aria-label", "Visual QA capture metadata");
  stamp.textContent = `${scene.id} · seed ${scene.seed} · t${scene.tick} · ${scene.quality} · ${BUILD_SHORT_SHA}`;
  host.appendChild(stamp);
}
